module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "10"
    }
  }, [_vm._l((_vm.dataItems), function(item) {
    return _c('div', {
      key: item._id,
      class: {
        'slats': true, 'highlight': _vm.highlightForm == item._id
      }
    }, [_c('div', {
      staticClass: "size3of4 unit clickable",
      on: {
        "click": function($event) {
          return _vm.onRowClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "size5of8 unit"
    }, [_c('form-icon', {
      attrs: {
        "form": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "form-description"
    }, [_vm._v(_vm._s(item.description))])], 1), _vm._v(" "), _c('div', {
      staticClass: "size3of8 unit"
    }, [_c('div', {
      staticClass: "data"
    }, [(item.filledCount) ? _c('div', [_c('h4', [_vm._v(_vm._s(item.filledCount))]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("submissions")])]) : _c('div', [_c('h4', {
      staticClass: "text-muted"
    }, [_vm._v("0")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("submissions")])])]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [(item.lastFilledForm) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.formatTimeAgo(item.lastFilledForm)))]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("ago")])]) : _c('div', [_c('h4', {
      staticClass: "text-muted"
    }, [_vm._v("no")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("activity")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "size1of4 unit text-right"
    }, [_c('form-actions', {
      attrs: {
        "form": item
      },
      on: {
        "on-settings": _vm.onFormSettings
      }
    })], 1)])
  }), _vm._v(" "), (!_vm.isFullList && _vm.loading) ? _c('div', {
    staticClass: "text-muted loading-list"
  }, [_c('span', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n      Loading...\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isFullList && !_vm.loading) ? _c('div', {
    staticClass: "text-center loading-list"
  }, [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore($event)
      }
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-down"
  }), _vm._v("\n        More...\n      ")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c67609"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/formsList.vue
// module id = 392
// module chunks = 4